import { gray40opacity40 } from '../../../colors/gray';
var indicator = {
    '&:hover': {
        backgroundColor: gray40opacity40,
    },
};
export var MuiAutocomplete = {
    styleOverrides: { clearIndicator: indicator, popupIndicator: indicator },
};
